import React, { useEffect, useState } from 'react';
import { 
  BookOpen, 
  Rocket, 
  LineChart, 
  Award, 
  Target, 
  CheckCircle, 
  Calendar, 
  MapPin, 
  Users, 
  Briefcase, 
  ArrowRight, 
  ShieldCheck, 
  TrendingUp, 
  Mail, 
  Phone, 
  GraduationCap, 
  Star,
  Zap,
  Bell,
  ExternalLink
} from 'lucide-react';


import inaugration from "../global-images/inaugration_Img.jpeg";
import SOElogo from "../global-images/Final SOE logo.png";
import courseBrochure from "../global-images/Course.pdf";
import empowerHerBrochure from "../global-images/EMPOWERHER.pdf";

const inaugrationPlaceholder = "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop";
const SOElogoPlaceholder = ""; 
const courseBrochurePlaceholder = "#";
const empowerHerBrochurePlaceholder = "#";

const SchoolOfEntrepreneurship = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const pillars = [
    {
      title: "LEARN",
      subtitle: "Ideation & Validation",
      description: "Nurturing an entrepreneurial mindset to identify real-world opportunities and validate innovative ideas through rigorous methodology.",
      icon: BookOpen,
      color: "text-blue-600",
      bgColor: "bg-blue-50"
    },
    {
      title: "BUILD",
      subtitle: "Execution & Mentorship",
      description: "Bridging the gap between conceptual foundations and real-world execution through hands-on startup building and expert guidance.",
      icon: Rocket,
      color: "text-orange-600",
      bgColor: "bg-orange-50"
    },
    {
      title: "SCALE",
      subtitle: "Growth & Leadership",
      description: "Developing future business leaders capable of building scalable ventures and leading with purpose in global markets.",
      icon: TrendingUp,
      color: "text-emerald-600",
      bgColor: "bg-emerald-50"
    }
  ];

  const courses = [
    {
      title: "Certificate Of Entrepreneurship Program",
      subtitle: "EDC India x IIT Ropar-TBIF",
      tag: "Certification Program",
      duration: "10 Days | 12 Sessions",
      date: "15 February 2026 Onwards",
      location: "IIT Ropar Campus (3 Days Immersive)",
      regLink: "https://www.buildupbharat.org/",
      brochureLink: typeof courseBrochure !== 'undefined' ? courseBrochure : courseBrochurePlaceholder,
      isHot: true,
      highlights: [
        "10 Mentors & 5 Angel Investors",
        "Investor-ready Pitch Deck & Finance",
        "Legal & Compliance Frameworks",
        "Mock Pitching with Expert Feedback",
        "Incubation Opportunity at TBIF"
      ],
      icon: Briefcase,
      accent: "blue"
    },
    {
      title: "EmpowerHer",
      subtitle: "Elite Program for Women Leaders",
      tag: "Women in Leadership",
      duration: "5 Days Immersive Journey",
      date: "16-20 March 2026",
      location: "Global Skill Park Campus, Bhopal",
      regLink: "https://forms.gle/haHSJexSbRVNASTG8",
      brochureLink: typeof empowerHerBrochure !== 'undefined' ? empowerHerBrochure : empowerHerBrochurePlaceholder,
      isHot: true,
      highlights: [
        "Revenue-focused Business Models",
        "Branding & Digital Visibility",
        "Pricing & Strategic Finance",
        "Leadership & Negotiation Skills",
        "Guided Final Pitch Showcase"
      ],
      icon: Users,
      accent: "rose"
    }
  ];

  const initiatives = [
    "MSME Innovative Scheme",
    "Startup India Alignment",
    "Skill India Integration",
    "Atmanirbhar Bharat Vision"
  ];

  // Asset Resolver
  const currentLogo = typeof SOElogo !== 'undefined' ? SOElogo : SOElogoPlaceholder;
  const currentInaugration = typeof inaugration !== 'undefined' ? inaugration : inaugrationPlaceholder;

  return (
    <div className="min-h-screen bg-slate-50 pt-20 pb-16 font-montserrat text-slate-900 overflow-x-hidden">
      {/* Professional Breathing Animations */}
      <style>
        {`
          @keyframes highAttention {
            0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.6); }
            70% { transform: scale(1.03); box-shadow: 0 0 0 15px rgba(37, 99, 235, 0); }
            100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 99, 235, 0); }
          }
          .animate-attention-high {
            animation: highAttention 2s infinite ease-in-out;
          }
          @keyframes statusGlow {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.6; transform: scale(1.15); }
          }
          .live-indicator {
            animation: statusGlow 2s infinite ease-in-out;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto px-5 md:px-12 mb-12 md:mb-20">
        <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          
          {/* Logo Section */}
          <div className="flex flex-col items-center mb-8 md:mb-12">
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-tr from-blue-600/30 to-indigo-600/30 rounded-full blur-2xl group-hover:blur-3xl transition-all duration-700 opacity-50"></div>
              
              <div className="w-28 h-28 md:w-48 md:h-48 bg-white rounded-full flex items-center justify-center relative overflow-hidden border-4 border-white shadow-2xl transition-all duration-500 group-hover:scale-105 z-10">
                {!imgError && currentLogo ? (
                  <img 
                    src={currentLogo} 
                    alt="SOE Logo" 
                    className="w-full h-full object-contain p-0" 
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-tr from-blue-700 to-indigo-900 flex items-center justify-center p-4">
                    <span className="text-2xl md:text-5xl font-black tracking-tighter text-white drop-shadow-lg text-center leading-none uppercase">SOE</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="text-center mb-8 md:mb-12 relative px-2">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 md:w-64 h-48 md:h-64 bg-blue-200/30 rounded-full blur-3xl -z-10"></div>
            <h1 className="text-4xl md:text-7xl font-extrabold tracking-tight mb-4 md:mb-6 leading-tight">
              School of <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">Entrepreneurship</span>
            </h1>
            <p className="text-lg md:text-2xl italic text-slate-500 font-medium max-w-3xl mx-auto mb-10">
              "Where Ideas Turn Into Impactful Enterprises"
            </p>

            {/* ENHANCED: Professional High-Visibility Floating Badge */}
            <div className="flex justify-center px-2">
              <a 
                href="#programs"
                className="inline-flex items-center gap-3 md:gap-5 bg-gradient-to-r from-rose-500 via-rose-600 to-pink-700 text-white px-6 md:px-12 py-5 md:py-8 rounded-3xl md:rounded-full shadow-[0_20px_40px_rgba(225,29,72,0.4)] animate-attention-high group transition-all hover:scale-105 active:scale-95 border border-white/20"
              >
                <div className="flex items-center justify-center bg-white/20 p-2 md:p-3 rounded-full live-indicator shadow-inner">
                  <Bell size={24} className="text-white" fill="white" />
                </div>
                <div className="flex flex-col items-start leading-tight">
                  <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.25em] text-rose-100 mb-1.5 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
                    Registrations Live For
                  </span>
                  <span className="font-black text-sm md:text-xl lg:text-2xl tracking-tight text-left mb-1">
                    EmpowerHer Program
                  </span>
                  <span className="text-[10px] md:text-xs font-bold  px-2 py-0.5 rounded italic">
                    Click Here to Register Now
                  </span>
                </div>
                <ArrowRight size={26} className="ml-2 md:ml-4 group-hover:translate-x-2 transition-transform duration-300 hidden sm:block" />
              </a>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center bg-white p-6 md:p-12 rounded-3xl md:rounded-[2.5rem] shadow-xl shadow-slate-200/60 border border-slate-100 mt-12 md:mt-16">
            <div className="space-y-6 md:space-y-8 order-2 lg:order-1">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-4 md:mb-6 flex items-center gap-3 md:gap-4">
                  About the School
                </h2>
                <div className="space-y-4 text-slate-600 text-base md:text-lg leading-relaxed">
                  <p>
                    The School of Entrepreneurship (SoE) at IIT Ropar-TBIF is a dedicated 
                    <span className="font-semibold text-blue-600"> academic ecosystem</span> focused on developing job creators and future business leaders through structured, industry-aligned education.
                  </p>
                  <p>
                    We bridge the gap between academic theory and real-world execution by combining rigorous conceptual foundations with hands-on startup building.
                  </p>
                </div>
              </div>
              
              <div className="flex flex-wrap gap-3 md:gap-4 pt-2 md:pt-4">
                <div className="flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-slate-50 rounded-lg text-xs md:text-sm font-semibold text-slate-700 border border-slate-100">
                  <ShieldCheck size={16} className="text-blue-600" /> IIT Ropar Initiative
                </div>
                <div className="flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-slate-50 rounded-lg text-xs md:text-sm font-semibold text-slate-700 border border-slate-100">
                  <Star size={16} className="text-yellow-500" /> Premium Mentorship
                </div>
              </div>
              
              <div className="p-5 md:p-6 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl text-white shadow-lg shadow-blue-200/50">
                <p className="text-[10px] md:text-xs opacity-80 uppercase tracking-widest font-bold mb-1 md:mb-2">Inaugurated By</p>
                <p className="text-lg md:text-xl font-bold">Prof. Rajeev Ahuja</p>
                <p className="text-xs md:text-sm opacity-90">Director, IIT Ropar</p>
              </div>
            </div>
            
            <div className="relative group order-1 lg:order-2">
              <div className="absolute -inset-4 bg-gradient-to-tr from-blue-600 to-indigo-600 rounded-3xl md:rounded-[2.5rem] blur-2xl opacity-10 group-hover:opacity-30 transition-all duration-700"></div>
              <div className="relative bg-white p-2 md:p-4 rounded-2xl md:rounded-[2rem] shadow-2xl border border-slate-100 transform md:rotate-1 group-hover:rotate-0 group-hover:-translate-y-2 transition-all duration-700 ease-out overflow-hidden cursor-pointer">
                <div className="relative aspect-square md:aspect-[4/3] rounded-xl md:rounded-2xl overflow-hidden bg-slate-100">
                  <img 
                    src={currentInaugration} 
                    alt="School of Entrepreneurship Inauguration" 
                    className="w-full h-full object-cover group-hover:scale-125 transition-transform duration-[1500ms] ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6 md:p-8">
                    <div className="transform translate-y-6 group-hover:translate-y-0 transition-transform duration-700 ease-out">
                      <p className="text-white text-xs md:text-sm font-bold uppercase tracking-[0.2em] mb-1">Building Future Leaders</p>
                      <p className="text-blue-300 text-[10px] md:text-xs font-medium italic">Inauguration Ceremony at IIT Ropar</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pillars Section */}
        <div className="mt-20 md:mt-32">
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">The Core Pillars</h2>
            <div className="w-16 md:w-20 h-1 bg-blue-600 mx-auto mt-4 rounded-full"></div>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {pillars.map((pillar, idx) => {
              const Icon = pillar.icon;
              return (
                <div key={idx} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-slate-100 hover:shadow-xl transition-all duration-500 group">
                  <div className={`${pillar.bgColor} ${pillar.color} w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-6 md:mb-8 group-hover:scale-110 transition-transform`}>
                    <Icon size={30} />
                  </div>
                  <h3 className={`text-xl md:text-2xl font-black mb-1 ${pillar.color}`}>{pillar.title}</h3>
                  <p className="text-[10px] md:text-xs font-bold text-slate-400 uppercase tracking-widest mb-4 md:mb-6">{pillar.subtitle}</p>
                  <p className="text-sm md:text-base text-slate-600 leading-relaxed font-medium">
                    {pillar.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Flagship Programs Section */}
        <div id="programs" className="mt-20 md:mt-32 scroll-mt-28">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 md:mb-16 gap-6 px-2">
            <div className="text-left">
              <div className="flex items-center gap-2 mb-2">
                <Bell size={18} className="text-blue-600 live-indicator" />
                <span className="text-blue-600 font-black uppercase tracking-[0.2em] text-[10px] md:text-xs">Admissions Active</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-black text-slate-900 mt-2 leading-tight">Upcoming Programs</h2>
            </div>
          </div>

          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
            {courses.map((course, idx) => {
              const Icon = course.icon;
              const isRose = course.accent === 'rose';
              return (
                <div key={idx} className="bg-white rounded-3xl md:rounded-[2rem] overflow-hidden shadow-lg border border-slate-100 flex flex-col group hover:shadow-2xl transition-all duration-500 relative">
                  


                  <div className={`h-2 md:h-3 ${isRose ? 'bg-rose-500' : 'bg-blue-600'}`}></div>
                  <div className="p-6 md:p-10 flex-1 flex flex-col">
                    <div className="flex justify-between items-start mb-6">
                      <div className={`${isRose ? 'bg-rose-50 text-rose-600' : 'bg-blue-50 text-blue-600'} px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest`}>
                        {course.tag}
                      </div>
                      <Icon className={isRose ? 'text-rose-100' : 'text-blue-100'} size={32} />
                    </div>
                    
                    <h3 className="text-2xl md:text-3xl font-black text-slate-900 mb-2 leading-tight">{course.title}</h3>
                    <p className={`text-sm md:text-base font-bold ${isRose ? 'text-rose-600' : 'text-blue-600'} mb-6 md:mb-8`}>{course.subtitle}</p>
                    
                    <div className="space-y-3 md:space-y-4 mb-8 md:mb-10">
                      <div className="flex items-center gap-3 text-slate-600 text-sm md:text-base font-semibold">
                        <Calendar size={18} className={isRose ? 'text-rose-500' : 'text-blue-600'} />
                        {course.date}
                      </div>
                      <div className="flex items-center gap-3 text-slate-600 text-sm md:text-base font-semibold">
                        <MapPin size={18} className={isRose ? 'text-rose-500' : 'text-blue-600'} />
                        {course.location}
                      </div>
                      <div className="flex items-center gap-3 text-slate-500 text-[11px] md:text-sm font-medium">
                        <CheckCircle size={18} className="text-slate-300" />
                        {course.duration}
                      </div>
                    </div>

                    <div className="bg-slate-50 rounded-2xl p-5 md:p-6 mb-8 border border-slate-100">
                      <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-4">Focus Areas</p>
                      <ul className="grid gap-3">
                        {course.highlights.map((item, i) => (
                          <li key={i} className="flex items-start gap-3 text-xs md:text-sm text-slate-700 font-medium">
                            <CheckCircle size={14} className={isRose ? 'text-rose-500 mt-0.5' : 'text-blue-600 mt-0.5'} />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mt-auto pt-4 flex flex-col sm:flex-row gap-3 md:gap-4">
                        <a 
                          href={course.regLink} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className={`flex-1 ${isRose ? 'bg-rose-600 hover:bg-rose-700 shadow-rose-200' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-200'} text-white font-black py-4 rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 group text-center uppercase text-[10px] md:text-xs tracking-widest animate-attention-high`}
                        >
                            Apply Now <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                        </a>
                        <a 
                          href={course.brochureLink} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="px-6 py-4 bg-slate-100 text-slate-700 font-black rounded-xl hover:bg-slate-200 transition-colors text-center uppercase text-[10px] md:text-xs tracking-widest flex items-center justify-center gap-2"
                        >
                            Brochure <ExternalLink size={14} />
                        </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolOfEntrepreneurship;